import { createFileRoute } from "@tanstack/react-router";

import CreditsPage from "@/app/CreditsPage";

export const Route = createFileRoute("/credits")({
  component: CreditsPage,
});
